import { Injectable, signal } from '@angular/core';
import { Contact } from '@modules/contacts/shared/models/contact.model';
import { ManagePanelService } from '@shared/services/manage-panel.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactManagePanelService extends ManagePanelService {
  private _contactData = new BehaviorSubject<Contact | null>(null);

  initData = signal(null);

  contactData$ = this._contactData.asObservable();

  setContactData(data: Contact) {
    this._contactData.next(data);
  }

  reset(): void {
    super.reset();
    this._contactData.next(null);
  }
}
